var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90006 6.96006C7.96317 7.02265 7.99866 7.10785 7.99866 7.19673C7.99866 7.28561 7.96317 7.37081 7.90006 7.4334L7.4334 7.90006C7.37081 7.96317 7.28561 7.99866 7.19673 7.99866C7.10785 7.99866 7.02265 7.96317 6.96006 7.90006L4.00006 4.94006L1.04006 7.90006C0.977475 7.96317 0.892277 7.99866 0.803398 7.99866C0.714518 7.99866 0.62932 7.96317 0.566731 7.90006L0.100064 7.4334C0.0369601 7.37081 0.00146484 7.28561 0.00146484 7.19673C0.00146484 7.10785 0.0369601 7.02265 0.100064 6.96006L3.06006 4.00006L0.100064 1.04006C0.0369601 0.977475 0.00146484 0.892277 0.00146484 0.803398C0.00146484 0.714518 0.0369601 0.62932 0.100064 0.566731L0.566731 0.100064C0.62932 0.0369601 0.714518 0.00146484 0.803398 0.00146484C0.892277 0.00146484 0.977475 0.0369601 1.04006 0.100064L4.00006 3.06006L6.96006 0.100064C7.02265 0.0369601 7.10785 0.00146484 7.19673 0.00146484C7.28561 0.00146484 7.37081 0.0369601 7.4334 0.100064L7.90006 0.566731C7.96317 0.62932 7.99866 0.714518 7.99866 0.803398C7.99866 0.892277 7.96317 0.977475 7.90006 1.04006L4.94006 4.00006L7.90006 6.96006Z",
    fill: "#9DACBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconModal);
export default __webpack_public_path__ + "static/media/close_icon_modal.85698d48555e6dc38c252089ef715ed2.svg";
export { ForwardRef as ReactComponent };